import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators
} from '@angular/forms';
import { AppConfigSettings, ArcValidators } from '@arc/arc-shared-frontend';

@Component({
  selector: 'app-authentication-forgotpassword',
  styleUrls: ['./forgotpassword.component.scss'],
  templateUrl: './forgotpassword.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordComponent implements OnInit {
  @Input()
  email;
  @Output()
  resetPasswordClicked = new EventEmitter<any>();
  @Output()
  goBackClicked = new EventEmitter<any>();
  @Output()
  goToVerificationCodeClicked = new EventEmitter<any>();

  forgotPasswordForm: UntypedFormGroup;

  constructor(public settings: AppConfigSettings) {}

  ngOnInit() {
    this.forgotPasswordForm = new UntypedFormGroup(
      {
        email: new UntypedFormControl('', {
          validators: [Validators.required, ArcValidators.email]
        })
      },
      { updateOn: 'submit' }
    );

    this.forgotPasswordForm.patchValue({ email: this.email });
  }

  resetPassword() {
    if (this.forgotPasswordForm.valid) {
      this.resetPasswordClicked.emit(this.emailControl.value);
    } else {
      this.emailControl.markAsTouched();
    }
  }

  goBack() {
    this.goBackClicked.emit();
  }

  goToVerificationCode() {
    this.goToVerificationCodeClicked.emit();
  }

  get emailControl() {
    return this.forgotPasswordForm.get('email');
  }
  get emailIsInValid() {
    return this.emailControl.errors && this.emailControl.touched;
  }
}
